import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import ShopifyAppContext from '../shopify/shopifyappcontext.js'
import NewExternalUserModal from './newexternalusermodal.component.jsx'
const queryString = require('query-string')

class ExternalSignIn extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)

        if (!uri.response_type) {
            uri.response_type = 'code'
        }
        if (!uri.redirect_uri) {
            uri.redirect_uri = AppContext.getOptions().webCpqUrl + '/auth'
        }
        if (!uri.client_id) {
            const options = AppContext.getOptions()
            switch (options.environment) {
                case 'dev':
                    uri.client_id = 'web-cpq'
                    break
                case 'staging':
                    uri.client_id = 'staging-web-cpq'
                    break
                case 'release-candidate':
                    uri.client_id = 'rc-web-cpq'
                    break
                case 'prod':
                    uri.client_id = 'prod-web-cpq'
                    break
            }
        }

        this.state = {
            uri: uri,
            integrationKey: this.props.match.params.integrationKey,
            sessionToken: uri.sessionToken,
        }
    }

    componentDidMount() {
        if (this.state.integrationKey.includes('shopify')) {
            this.handleShopifySignIn()
        } else {
            window.location = '/'
        }
    }

    handleShopifySignIn() {
        if (this.state.uri.shop && !this.state.sessionToken) {
            //if not inside iframe
            if (window.self == window.top && this.state.uri.install === "true") {
                fetch('/session', {
                    credentials: "same-origin"
                }).then(res => {
                    if (res.status == 200) {
                        window.location = '/embed/connect/' + this.state.integrationKey + '?' +
                            queryString.stringify(this.state.uri)
                    } else {
                        window.location = AppContext.getOptions().apiUrl +
                            '/openid/signup/' + this.state.integrationKey + '?' +
                            queryString.stringify(this.state.uri)
                    }
                })
                return
            }
            ShopifyAppContext.setOrigin(this.state.uri.shop, this.state.uri.host, this.state.integrationKey)
                .then(_ => ShopifyAppContext.getSessionTokenPromise())
                .then(shopifySessionToken => {
                ShopifyAppContext.getAppState().then(appState => {
                    console.log(appState)
                    console.log('redirecting to ' + AppContext.getOptions().apiUrl +
                        '/openid/session-authorize/' + this.state.integrationKey + '?' +
                        queryString.stringify(this.state.uri) + `&sessionToken=${shopifySessionToken}&accountAccess=${appState.staffMember.accountAccess}`)
                    window.location = AppContext.getOptions().apiUrl +
                        '/openid/session-authorize/' + this.state.integrationKey + '?' +
                        queryString.stringify(this.state.uri) + `&sessionToken=${shopifySessionToken}&accountAccess=${appState.staffMember.accountAccess}`
                })
            })
        }
    }

    render() {
        return this.state.sessionToken ?
            <NewExternalUserModal
                integrationKey={this.state.integrationKey}
                uri={this.state.uri}
                sessionToken={this.state.sessionToken}
            /> :
            <div className="text-center">
                <LoadingSpinner marginTop="20px" />
                <FormattedMessage
                    id="signin.external.loading"
                    defaultMessage="Signing in to QuoteMachine..."
                />
            </div>
    }

}

export default ExternalSignIn





// WEBPACK FOOTER //
// ./src/auth/externalsignin.component.jsx